import React, {useEffect, useMemo} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import CssBaseline from '@mui/material/CssBaseline';

import Navigation from '../../navigation';
import {useDispatch, useSelector, shallowEqual} from 'react-redux';
import {IStore} from "../../store/types";
import {IAuth, AuthStatus} from "../../store/types/auth";
import {Auth} from "../../store/slices";
import { getTheme } from '../../theme';
import SessionKeeper from '../../auth/SessionKeeper';

const Root = () => {
    const dispatch = useDispatch();
    const {
        auth,
        status,
        themeMode
    } = useSelector<IStore, { auth: IAuth, status: AuthStatus, themeMode: 'light' | 'dark' }>(state => ({
        auth: state.auth.data,
        status: state.auth.status,
        themeMode: state.theme.mode
    }), shallowEqual)

    useEffect(() => {
        dispatch<any>(Auth.getAuthenticatedUser());
    }, [dispatch])

    const theme = useMemo(() => getTheme(themeMode), [themeMode]);

  return (
    <MuiThemeProvider theme={theme}>
        <JssThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
              <SessionKeeper />
              <Navigation auth={auth} status={status} />
            </BrowserRouter>
        </JssThemeProvider>
    </MuiThemeProvider>
  );
};

export default Root;
